export * from './ProductMain'

export type { ProductMainProps } from './ProductMain.types'
